module.exports = __webpack_public_path__ + "static/media/scelles-blue.45879366.png";